
import React from 'react';
import {
    FormControl, FormControlLabel,
    InputLabel, Radio, RadioGroup
} from "@deere/fuel-react";
import {Controller} from "react-hook-form";

export const FormRadio = ({defState, name, options, onTypeChange, control, showLabel, rowID="", isDisabled=false, isRow=true}) => {
    return (
        <FormControl required fullWidth p={2} component="fieldset" disabled={isDisabled}>
            {showLabel && (<InputLabel component="legend">Response Type</InputLabel>)}
            <Controller
                rules={{required: true}}
                control={control}
                defaultValue={defState}
                name={name}
                render={({onChange, value}) => (
                    <RadioGroup
                        aria-label={name}
                        name={name}
                        value={defState}
                        onChange={(e) => {
                            onChange(e);
                            onTypeChange(e,rowID);
                        }}
                        row = {isRow}>
                        {options && options.map((item) => {
                            return (
                                <FormControlLabel key={item.value} value={item.value} control={<Radio/>}
                                                  label={item.label} disabled = {item.value.indexOf("undefined") >= 0 ? true : false}/>
                            );
                        })}
                    </RadioGroup>
                )}
            />
        </FormControl>
    );
};